import NurseryAdmissions from "../components/pages/NurseryAdmission";

export default NurseryAdmissions;
